export class AbilityListDTO {

    id: string;

    abilityType: number;

    from: Date | string;

    to: Date | string;

}
